<template>
    <el-dialog :visible.sync="showDialog" @open="loadEquipment" @close="closeDialog" width="40%" :close-on-click-modal="false">
        <template slot="title">
            <span>
                {{$t('equipments.equipmentRegistration')}}
                <el-button @click="createCustomer" type="primary" size="mini" v-if="!equipmentId">
                    {{$t('equipments.createCustomer')}}
                </el-button>
            </span>
        </template>
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
            <el-form-item :label="$t('common.customer')" prop="customerId">
                <customer-selector v-model="form.customerId"></customer-selector>
            </el-form-item>

            <el-form-item :label="$t('common.product')" prop="productId">
                <product-selector v-model="form.productId" @serialUpdate="serialUpdated" :disabled="this.updateMode"></product-selector>
            </el-form-item>

            <el-form-item :label="$t('common.serialNumber')" prop="serialNumber">
                <el-input v-model="form.serialNumber" :disabled="this.updateMode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('equipments.gasType')" prop="gasType">
                <el-select v-model="form.gasType" class="full-width">
                    <el-option :value="0" :label="$t('equipments.notApplicable')"></el-option>
                    <el-option :value="1" :label="$t('equipments.natural')"></el-option>
                    <el-option :value="2" :label="$t('equipments.propane')"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('equipments.shippingDate')" prop="shippingDate">
                <el-date-picker class="full-width" v-model="form.shippingDate" type="date" ></el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('equipments.installationDate')" prop="installationDate">
                <el-date-picker class="full-width" v-model="form.installationDate" type="date"  :picker-options="installationDatePickerOptions"></el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('common.warrantyStart')" prop="warrantyStart">
                <el-date-picker class="full-width" v-model="form.warrantyStart" type="date" ></el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('common.warrantyEnd')" prop="warrantyEnd">
                <el-date-picker class="full-width" v-model="form.warrantyEnd" type="date" ></el-date-picker>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button v-if="!this.updateMode" :loading="loading" :disabled="loading" type="success" @click="save(true)">{{$t('equipments.copyAndCreate')}}</el-button>
            <el-button :loading="loading" :disabled="loading" type="primary" @click="save(false)">
                <span v-if="this.updateMode">{{$t('common.update')}}</span>
                <span v-else="this.updateMode">{{$t('common.create')}}</span>
            </el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { ProductSelector, CustomerSelector } from "@/app/shared/components";
    import { EventBus } from "@/app/event-bus.js";
    import api from "../api";
    export default {
        name: "equipment-registration-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            equipmentId: {
                required: false
            }
        },
        components: {
            ProductSelector,
            CustomerSelector
        },
        data() {
            var checkSerial = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("Please input serial number"));
                }

                if (!this.serialPrefix) {
                    return callback(new Error(this.$t('common.pleaseSelectProductFirst')));
                }

                var validSerial = false;
                var errorMessage = this.$t('common.pleaseEnterName') + ` YYMM${this.serialPrefix}`;
                var regex = new RegExp(`^(\\d{2})(\\d{2})(${this.serialPrefix})(\\w+)$`);
                if (this.form.productId == 108) {
                    regex = new RegExp(`^(\\d{2})(\\d{2})(${this.serialPrefix})(.{4})$`);
                    errorMessage = this.$t('common.pleaseEnterName') + ` YYMM${this.serialPrefix}****`
                }
                if (regex.test(value)) {
                    var month = Number.parseInt(regex.exec(value)[2]);
                    if (month > 0 && month <= 12) {
                        validSerial = true;
                    }
                }

                if (validSerial) {
                    return callback();
                } else {
                    return callback(
                        new Error(
                            errorMessage
                        )
                    );
                }
            };
            return {
                form: {
                    customerId: undefined,
                    productId: undefined,
                    serialNumber: "",
                    gasType: 0,
                    shippingDate: "",
                    warrantyStart: "",
                    warrantyEnd: "",
                    installationDate: ""
                },
                rules: {
                    customerId: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('shared.pleaseSelectCustomer'),
                            trigger: "change"
                        }
                    ],
                    productId: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('shared.pleaseSelectProduct'),
                            trigger: "change"
                        }
                    ],
                    serialNumber: [
                        {
                            validator: checkSerial,
                            required: true,
                            trigger: "blur"
                        }
                    ],
                    gasType: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseSelectGasType'),
                            trigger: "change"
                        }
                    ],
                    shippingDate: [
                        {
                            type: "date",
                            required: true,
                            message: this.$t('common.pleaseSelectShippingDate'),
                            trigger: "blur"
                        }
                    ],
                    warrantyStart: [
                        {
                            type: "date",
                            required: true,
                            message: this.$t('common.pleaseEnterWarrantyStartDate'),
                            trigget: "blur"
                        }
                    ],
                    warrantyEnd: [
                        {
                            type: "date",
                            required: true,
                            message: this.$t('common.pleaseEnterWarrantyEndDate'),
                            trigget: "blur"
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                customerCreateDialogVisible: false,
                serialPrefix: undefined,
                updateMode: false,
                installationDatePickerOptions: {
                    disabledDate: this.disabledInstallationDate
                },
                installationDateChanged: false
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            },
            "form.productId": function (val) {
                if (this.form.serialNumber) {
                    this.$refs.form.validateField("serialNumber");
                }
            },
            "form.shippingDate": function (val) {
                if (!this.updateMode || this.form.warrantyStart == "") {
                    var shippingDatePlus8 = new Date(this.form.shippingDate);// add 8 weeks to ship date or installation date whichever occurred first
                    shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
                    this.form.warrantyStart = this.form.installationDate == "" || shippingDatePlus8 < this.form.installationDate ? new Date(shippingDatePlus8) : new Date(this.form.installationDate);
                }
            },
            "form.installationDate": function (val) {
                var shippingDatePlus8 = new Date(this.form.shippingDate);
                shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
                this.form.warrantyStart = this.form.shippingDate == "" || shippingDatePlus8 > this.form.installationDate ? new Date(this.form.installationDate) : shippingDatePlus8;
                this.installationDateChanged = true;
            },
            "form.warrantyStart": function (val) {
                if (!this.updateMode || this.form.warrantyEnd == "" || this.installationDateChanged) {
                    this.form.warrantyEnd = new Date(this.form.warrantyStart);
                    this.form.warrantyEnd.setFullYear(
                        this.form.warrantyEnd.getFullYear() + 2
                    ); // add 2 years
                    this.installationDateChanged = false;
                }
            }
        },
        mounted() {
            var self = this;
            EventBus.$on("saveCustomer", id => {
                this.form.customerId = id;
            });
        },
        methods: {
            serialUpdated(serial) {
                this.serialPrefix = serial;
            },
            loadEquipment() {
                if (this.equipmentId) {
                    this.loading = true;
                    this.updateMode = true;
                    api.getEquipment(this.equipmentId).then(equipment => {
                        this.form.customerId = equipment.data.customerId;
                        this.form.productId = equipment.data.productId;
                        this.form.serialNumber = equipment.data.serialNumber;
                        this.form.gasType = equipment.data.gasType;
                        this.form.shippingDate = new Date(equipment.data.shippingDate);
                        this.form.warrantyStart = new Date(equipment.data.warrantyStart);
                        this.form.warrantyEnd = new Date(equipment.data.warrantyEnd);
                        this.form.installationDate = equipment.data.installationDate ? new Date(equipment.data.installationDate) : "";
                        this.serialPrefix = equipment.data.serialPrefix;
                        this.loading = false;
                    });
                }
                else {
                    this.updateMode = false;
                }
            },
            closeDialog() {
                this.$refs["form"].resetFields();
                this.showDialog = false;
                this.loading = false;
                this.$emit("dialogClosed");
            },
            save(copyFlag) {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.saveEquipment(this.equipmentId, this.form).then(() => {
                            this.$emit("save");
                            this.$notify({
                                title: this.$t('common.success'),
                                message: this.$t('common.equipmentSuccessfullySaved'),
                                type: "success"
                            });
                            if (!copyFlag) {
                                this.closeDialog();
                            } else {
                                this.form.productId = undefined,
                                this.form.serialNumber = "",
                                this.loading = false;
                            }
                        }).catch((err) => {
                            if (err.response.status == 400) {
                                this.form.serialNumber = '';
                                this.$notify({
                                    title: "Error",
                                    message: this.$t('common.duplicateSerialNumber'),
                                    type: "error"
                                });
                            } else {
                                this.form.customerId = '';
                                this.form.productId = '';
                                this.$notify({
                                    title: "Error",
                                    message: this.$t('common.customerOrProductIsNotExists'),
                                    type: "error"
                                });
                            }
                            this.loading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            createCustomer() {
                EventBus.$emit("createCustomer");
            },
            disabledInstallationDate(time) {
                var shippingDatePlus8 = new Date(this.form.shippingDate);
                shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
                return time.getTime() < this.form.shippingDate || time.getTime() > shippingDatePlus8;
            }
        }
    };
</script>

<style scoped>
    .full-width {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/equipment/components/EquipmentRegistrationDialog.vue